// common
import React from 'react';

// style
import styled, { css } from 'styled-components';

import { getVariantTagStyle } from 'styles/components/getVariantStyle';
import { typography } from 'styles/token/typography';

/**
 * Tag 컴포넌트
 * @param {string} className - 추가 클래스명
 * @param {React.ReactNode} children - 태그 내부 내용
 * @param {string} variant - 스타일 타입 (yellow, red, API, SDK, FREE 등)
 * @param {Object} tagStyle - 추가적인 인라인 스타일
 */
const Tag = ({ className, children, variant, tagStyle }) => {
  return (
    <TagWrapper
      className={`tag ${className || ''}`}
      variant={variant}
      style={tagStyle}
    >
      {children}
    </TagWrapper>
  );
};

const AddressTag = css`
  width: 40px;
  min-width: 40px;
  height: 20px;
  line-height: 20px;
  padding: 0;
  word-break: keep-all;
  border-radius: 0;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: -0.03px;
  color: ${({ theme }) => theme.color.gray600};
  background: ${({ theme }) => theme.color.white};
  border: 1px solid ${({ theme }) => theme.color.gray100};
  border-radius: 4px;
  box-sizing: border-box;

  color: ${({ theme }) => theme.color.gray700};
  background: ${({ theme }) => theme.color.bg};
  border-color: ${({ theme }) => theme.color.blueGray100};

  &.bg {
    color: ${({ theme }) => theme.color.primary};
    background: ${({ theme }) => theme.color.primarybg};
    border-color: #e5ecff;
  }
`;

/** Tag 스타일 */
const TagWrapper = styled.span`
  border-radius: 2px;
  min-width: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 5px 8px;

  border-radius: 4px;
  background: #e0e9ff;
  color: ${({ theme }) => theme.color.primary};

  ${typography.labelMedium}
  line-height: normal;
  letter-spacing: 0.3px;
  font-weight: 500;

  /* variant 스타일 적용 */
  ${({ variant }) => getVariantTagStyle(variant)}

  &.address {
    ${AddressTag}
  }
  @media screen and (max-width: 768px) {
    min-width: max-content;
    padding: 4px 8px;
    border-radius: 20px;
  }
`;
const RoundTag = styled(Tag)`
  min-width: fit-content;
  height: auto;
  padding: 6px 10px;
  border-radius: 20px;
  ${typography.labelMedium}
  font-weight: 500;
  line-height: 1;
`;
const StatusTag = styled(Tag)`
  min-width: fit-content;
  height: auto;
  padding: 6px 8px;
  border-radius: 20px;
  ${typography.labelExtraSmall}
  font-weight: 500;
  line-height: 1;

  &.small {
    padding: 4px 6px;
  }
`;
const RoundLabel = styled(Tag)``;

const ApiTag = styled(Tag)`
  min-width: fit-content;
  /* padding: 4px 6px; */
  ${typography.labelSmall}
  font-weight: 400;
  line-height: 1;

  // 추후에 변경 부탁드립니다
  /* background: ${({ theme }) => theme.color.white};
  color: ${({ theme }) => theme.color.primary};
  border: 1px solid ${({ theme }) => theme.color.gray100}; */
  padding: 0;
  color: ${({ theme }) => theme.color.primary};
  background: ${({ theme }) => theme.color.white};
  border: none;
`;

/**
 * 메뉴 전용 태그 컴포넌트
 * @param {Object} item - 날짜 정보가 있는 객체
 * @param {string} variant - Tag 스타일
 */
Tag.Menu = ({ item, variant = 'blueGradient' }) => {
  if (!item) return null;

  const { isRecent, value } =
    require('utils/date/convertDateUtil').getMenuTagProps(item);

  if (!isRecent) return null;

  return (
    <StatusTag variant={variant} className="small">
      {value}
    </StatusTag>
  );
};

const Flex = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

const Main = styled.div`
  display: flex;
  overflow: hidden;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const Box = styled.div`
  @media screen and (max-width: 768px) {
    display: flex;
    align-items: center;
  }
`;

Tag.Status = StatusTag;
Tag.Round = RoundTag;
Tag.Label = RoundLabel;
Tag.Api = ApiTag;
Tag.Flex = Flex;
Tag.Main = Main;
Tag.Column = Column;
Tag.Box = Box;

export default Tag;
